<div class="asidebarNav d-flex gap-0 text-dark position-relative asidebarNav-colapse">
  <header
    class="d-flex gap-2 align-items-center w-100 justify-content-between sticky-top position-sticky mb-0 border-3 border-top border-danger">
    <figure class="overflow-hidden m-0 mx-auto" style="max-height: 48px;">
      <img alt="logo" class="w-100 h-100 object-fit-contain p-1" src="../../../assets/img/nav/LOGO.svg"
        style="max-height: 55px; max-width: 55px;">
    </figure>
  </header>

  <nav class="nav flex-column small gap-2 overflow-auto text-center px-2 small py-3"
    style="background-color: var(--bs-light-rgb);">
    <hr class="mt-1 mb-2">
    @if (!isRetailer) {
    <ng-container>
      @for (item of menuItems; track $index) {
      <a [routerLink]="item.route"
        class="px-0 py-2 border-0 gap-1 d-flex align-items-center justify-content-center flex-column btn text-secondary"
        routerLinkActive="bg-white active shadow-sm btn-light text-colonial" style="overflow-wrap: anywhere">
        <span class="material-symbols-outlined" style="font-size:34px;">
          {{item.icon}}
        </span>
        <small class="fw-semibold lh-sm"
          style="font-size: 12px; color:#868686 !important; overflow-wrap: normal;">{{item.name}}</small>
        @if (item.subtitle) {
        <small class="fw-normal" style="font-size: 10px; color: #868686;">
          {{ item.subtitle }}
        </small>
        }
      </a>
      }
    </ng-container>
    }
  </nav>

  <footer class="sticky-bottom z-1 position-sticky mb-2">
    <nav class="nav flex-column small px-2">
      <button (click)="logOut()"
        class="px-0 py-2 border-0 gap-1 d-flex align-items-center justify-content-center flex-column btn text-secondary"
        style="overflow-wrap: anywhere">
        <span class="material-symbols-outlined" style="font-size:34px ;">logout</span>
        <small class="fw-semibold lh-1" style="font-size: 12px;">Salir</small>
      </button>
    </nav>
  </footer>
</div>